import React from 'react';
import {
  SubmitButton,
  Tooltip,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import {
  PencilIcon,
  FloppyIcon,
} from '@fortress-technology-solutions/fortress-component-library/Icons';
import { Form } from '@fortress-technology-solutions/fortress-component-library/Organisms';
import SettingsCard from '../../../components/SettingsCard';
import useUnitAffordableSetup from './hooks';
import useHasPermission from '../../../hooks/useHasPermission';
import { useFlags } from 'launchdarkly-react-client-sdk';
import messages from './messages';

const UnitAffordableSetup = () => {
  const { affUnitDetails } = useFlags();
  const hasManageUnitsUpdatePermission = useHasPermission(
    'manage-units-update',
  );

  const {
    ReactHookFormProps,
    editMode,
    fields,
    handleToggleEditMode,
    isLoading,
    intl,
    isSubmitting,
    hasAnyAffordableProgram,
    hasEditableFields,
    isValid,
  } = useUnitAffordableSetup();

  if (!hasAnyAffordableProgram || !affUnitDetails) {
    return null;
  }

  const editButton = (
    <SubmitButton
      variant={'text'}
      startIcon={editMode ? <FloppyIcon /> : <PencilIcon />}
      isSubmitting={isSubmitting}
      onClick={handleToggleEditMode}
      disabled={(editMode && !isValid) || !hasEditableFields}
    >
      {editMode
        ? intl.formatMessage(messages.save)
        : intl.formatMessage(messages.edit)}
    </SubmitButton>
  );

  return (
    <SettingsCard
      title={intl.formatMessage(messages.unitAffordableSetup)}
      actions={
        hasManageUnitsUpdatePermission ? (
          hasEditableFields ? (
            editButton
          ) : (
            <Tooltip
              title={intl.formatMessage(messages.noEditableFieldsTooltip)}
            >
              <span>{editButton}</span>
            </Tooltip>
          )
        ) : null
      }
      isLoading={isLoading}
      sx={{ marginY: 3 }}
    >
      <Form ReactHookFormProps={ReactHookFormProps} fields={fields} />
    </SettingsCard>
  );
};

export default UnitAffordableSetup;
